import { AssigneeActions, IAssigneesStoreState } from "@gtmhub/assignees";
import { INgRedux } from "@gtmhub/state-management";
import { IdMap } from "@gtmhub/util";
import { ICollaborator } from "@gtmhub/whiteboards";
import { IComponentOptions } from "angular";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ViewMoreAvatarsCtrl extends ReturnType<typeof bindStateToThis> {}

const bindStateToThis = (state: IAssigneesStoreState) => {
  return {
    assigneesIdMap: state.assignees.map,
  };
};

export class ViewMoreAvatarsCtrl {
  public static $inject = ["$ngRedux", "AssigneeActions"];
  public collaborators: IdMap<ICollaborator>;
  limit: number;

  constructor($ngRedux: INgRedux, assigneeActions: AssigneeActions) {
    $ngRedux.connect(bindStateToThis)(this);
    $ngRedux.dispatch(assigneeActions.getAssignees());
  }

  $onInit() {
    /**
     * weird, yes, that's by requirement
     * if up to 5 collaborators => display them all
     * if more than 5 collaborators => display 4 on first line + the rest in a counter
     */
    this.limit = Object.keys(this.collaborators).length <= 5 ? 5 : 4;
  }
}

export const ViewMoreAvatarsComponent: IComponentOptions = {
  bindings: {
    collaborators: "<",
  },
  controller: ViewMoreAvatarsCtrl,
  templateUrl: require("./view-more-avatars.component.jade"),
};
